import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Box,
    Typography,
    Alert,
    Stack,
} from '@mui/material';
import RequestService from '../../services/RequestService';

const UserDeleteDialog = ({ open, onClose, user, onSuccess }) => {
    const handleSubmit = async () => {
        try {
            await RequestService.deletePlayer(user.id);
            onSuccess('Usuário excluído com sucesso!');
            onClose();
        } catch (err) {
            console.error(err);
        }
    };

    if (!user) {
        return null;
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Editar Usuário</DialogTitle>
            <DialogContent sx={{ padding: '32px 32px' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: 24,
                            fontWeight: '500',
                            color: '#0C3466',
                            mb: 3,
                        }}
                    >
                        Excluir jogador
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: 16,
                            fontWeight: '400',
                            color: '#0C3466',
                            mb: 2,
                        }}
                    >
                        Ao excluir um usuário, ele não terá mais acesso a
                        plataforma e caso ele seja tutor de alguma turma, será
                        necessário atribuir outro tutor.
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: 14,
                            fontWeight: '400',
                            color: '#0C3466',
                            mb: 1,
                        }}
                    >
                        Informações do Jogador
                    </Typography>
                    <Box
                        sx={{
                            padding: '24px 10px',
                            backgroundColor: '#EDF8FF',
                            borderRadius: '8px',
                        }}
                    >
                        <Stack flexDirection="row">
                            <Stack direction="column">
                                <Typography
                                    sx={{
                                        fontFamily: 'Poppins',
                                        fontSize: 12,
                                        fontWeight: '400',
                                        color: '#292929',
                                    }}
                                >
                                    {user.name}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontFamily: 'Poppins',
                                        fontSize: 12,
                                        fontWeight: '400',
                                        color: '#666666',
                                    }}
                                >
                                    {user.email}
                                </Typography>
                            </Stack>
                            <Typography
                                sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: 12,
                                    fontWeight: '400',
                                    color: '#292929',
                                }}
                            >
                                {user.role}
                            </Typography>
                        </Stack>
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined">
                    Cancelar
                </Button>
                <Button
                    onClick={handleSubmit}
                    color="primary"
                    variant="contained"
                >
                    Excluir usuário
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UserDeleteDialog;
